import React from "react";
import Layout from "../layout/Layout";
import Banner from "../components/linkedin/Banner";
import IndustryLeaders from "../components/industry-leaders/industry-leaders";
import FeatureGrid from "../components/linkedin/FeatureGrid";
import Cta from "../components/linkedin/Cta";
import Testimonials from "../components/linkedin/Testimonials";

const Linkedin = () => {
  return (
    <Layout>
      <Banner />
      <IndustryLeaders />
      <FeatureGrid />
      <Cta />
      <Testimonials />
    </Layout>
  );
};

export default Linkedin;
